import List from "./List.js";
import Show from "./Show.js";
import Edit from "./Edit.js";

export default { List, Show, Edit };
